module.exports = __webpack_public_path__ + "assets/4984c5af16dd4a494e14bdc67fcd7d8f.png";